import axios from 'axios'
import { API_URL } from '@/services/api'
import { getAuthToken } from '@/services/sessionProps'
import { handleCatch } from '../helpers/axiosHelpers'

axios.defaults.headers.common = {
  Authorization: `Bearer ${getAuthToken()}`,
}

const CampaignService = {
  async sendData (data) {
    try {
      return await axios.post(`${API_URL}/campaign-send`, data, { timeout: 1000 })
    } catch (error) {
    }
  }
}

/* eslint-disable import/prefer-default-export */
export function getCampaignService () {
  return CampaignService
}
